export default __webpack_public_path__ + "static/media/25.375e8576.png";